<template>
  <div class="layout-user-wx-bind-login">
    <slot :login="handleLogin"
          :logging="logging"></slot>
    <el-dialog width="280px"
               :visible.sync="logging"
               :append-to-body="true"
               :show-close="false"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               custom-class="layout-user-wx-bind-login-dialog">
      <div class="login-status">
        <i class="el-icon-loading"></i>
        <span>登录中...</span>
        <span class="login-id theme-text console-font">{{user.loginId}}</span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'WxBindLogin',
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      logging: false
    }
  },
  methods: {
    handleLogin () {
      this.logging = true
      this.$ajax({
        url: '/index/ws/wx/bind/login',
        method: 'post',
        disableErrorPage: true,
        data: this.$qs.stringify({
          loginId: this.user.loginId
        })
      }).then((response) => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              const redirectUrl = response.data.redirectUrl
              this.$emit('redirect', redirectUrl)
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              this.logging = false
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
        this.logging = false
      })
    }
  }
}
</script>

<style lang="scss">
  .layout-user-wx-bind-login {
    display: inline-block;
  }
  .layout-user-wx-bind-login-dialog {
    .el-dialog__header {
      display: none;
    }
    .el-dialog__body {
      .login-status {
        color: #303133;
        font-size: 12px;
        text-align: center;
        padding: 30px 15px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        i {
          margin-right: 2px;
          font-size: 14px;
          vertical-align: -1px;
        }
        .login-id {
          margin-left: 5px;
          font-size: 13px;
          font-weight: bold;
        }
      }
    }
  }
</style>
